module.exports = "<svg viewBox=\"0 0 43 38\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title></title><desc>Created with Sketch.</desc><defs></defs><g id=\"Home\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" font-size=\"40\" font-family=\"FontAwesome\" font-weight=\"normal\"><g transform=\"translate(-760.000000, -2021.000000)\" id=\"Group-6\" fill=\"#5E7E94\"><g transform=\"translate(150.000000, 1745.000000)\"><text id=\"\"><tspan x=\"610\" y=\"311\"></tspan></text></g></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/computer-screen.svg
// module id = 532
// module chunks = 1